// THE PAYMENT BUTTONS, their own component because of one MUI behaviour.
//
// MUI decides controlled-or-uncontrolled ONCE, at mount: useControlled latches
// on `controlled !== undefined` and never looks again. The cashier's editor is
// empty for the first render of an existing order -- the document arrives a
// tick later -- so a RadioGroup fed `editor.value?.payType` mounted
// uncontrolled, and the payType that followed was ignored for the life of the
// page. An order saved as 信用卡 opened with nothing selected.
//
// Hence the `?? ''` below, and hence a component at all: showing the bug means
// rendering the group across that empty-then-loaded transition, which could not
// be done while it lived inline in Cashier.jsx.

import PropTypes from 'prop-types'

import FormControl from '@mui/material/FormControl'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'

export default function PaymentMethod({ value, onChange }) {
  return (
    <FormControl style={{ flexGrow: 1 }}>
      <RadioGroup
        // Never undefined, so the group is controlled from its first render.
        value={value ?? ''}
        onChange={onChange}
        style={{
          flexDirection: 'row',
          justifyContent: 'space-evenly',
        }}
      >
        <FormControlLabel
          value="現金"
          control={<Radio color="primary" />}
          label={<span style={{ fontSize: '1.5rem' }}>現金</span>}
        />
        <FormControlLabel
          value="信用卡"
          control={<Radio color="primary" />}
          label={<span style={{ fontSize: '1.5rem' }}>信用卡</span>}
        />
        <FormControlLabel
          value="LINE PAY"
          control={<Radio color="primary" />}
          label={<span style={{ fontSize: '1rem' }}>LINE PAY</span>}
        />
        {/* 街口 is no longer accepted, and appears only on an order that
            already used it. A new order's payType is never 街口, so this cannot
            be chosen -- it exists so an old order shows what it was actually
            paid with rather than no selection at all. Switching such an order
            to another method removes the button for good, which is right: it is
            not a choice on offer any more. */}
        {value === '街口' ? (
          <FormControlLabel
            value="街口"
            control={<Radio color="primary" />}
            label={<span style={{ fontSize: '1.5rem' }}>街口</span>}
          />
        ) : null}
      </RadioGroup>
    </FormControl>
  )
}

PaymentMethod.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}
